import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropdown-input dropdown border-default bg-primary-white w-100 outline-none caption d-flex align-items-center" }
const _hoisted_2 = {
  class: "label",
  style: {"z-index":"1"}
}

import {useStore} from "vuex"
import { ref, computed } from "vue";
import DatePicker from "@/vue/planning/components/search/DatePickerV2.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'flightDatePicker',
  setup(__props) {

const store = useStore()
const showDatePicker = ref<boolean>(false)

const toggleShowHideDatePicker = (show: boolean): void => {
    showDatePicker.value = show
}

// Computed properties
const content = computed(() => store.state.content)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "dropdown-container position-relative col",
    onClick: _cache[1] || (_cache[1] = () => toggleShowHideDatePicker(true))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(DatePicker, {
        show: showDatePicker.value,
        onClose: _cache[0] || (_cache[0] = () => toggleShowHideDatePicker(false))
      }, null, 8, ["show"])
    ]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(content.value.flight_arrival_departure), 1)
  ]))
}
}

})